import { QueryClientProvider } from "@tanstack/react-query";
import { LazyMotion, MotionConfig } from "framer-motion";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { trackAppHeight } from "./appHeight";
import { queryClient } from "./api/queryClient";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { SupabaseProvider } from "./supabase/SupabaseContext";

// Before the first render, so the shell is laid out against a measured
// viewport rather than one iOS is still settling. See appHeight.ts.
trackAppHeight();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      {/* The feature set the `m` components across the app compile against —
          transforms, opacity, and the drag gestures the bottom sheet dismisses
          on (see motionFeatures.ts for why it's the larger set). Passing it as
          a dynamic import keeps it out of the main bundle — it arrives in its
          own chunk a beat after first paint, which is the right trade on a
          phone: the very first render is static, then animations take over.
          reducedMotion="user" drops the translation for anyone who's asked
          their OS for less motion, keeping only the opacity fade. */}
      <LazyMotion features={() => import("./motionFeatures").then((m) => m.default)} strict>
        <MotionConfig reducedMotion="user">
          <SupabaseProvider>
            <App />
          </SupabaseProvider>
        </MotionConfig>
      </LazyMotion>
      {/* <ReactQueryDevtools initialIsOpen={true} /> */}
    </React.StrictMode>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registers src/service-worker.ts (production builds only) — precaches the
// app shell so repeat visits and flaky mobile connections feel instant.
serviceWorkerRegistration.register();
